import { Suspense, startTransition } from "react";
import dynamic from "next/dynamic";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import LayoutMain from "@/layouts/Main";

import type { NextPageWithLayout } from "@/pages/_app";
import type { GetStaticProps } from "next";

const ViewPromotion = dynamic(() => import("@/views/PromotionDetail"), {
  suspense: true,
  ssr: false,
});

const Promotion: NextPageWithLayout = () => {
  return (
    <Suspense fallback="...">
      <ViewPromotion />
    </Suspense>
  );
};

Promotion.getLayout = (page) => {
  return <LayoutMain>{page}</LayoutMain>;
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || "")),
    },
  };
};

export default Promotion;
